/*
 * @Description: 确认弹窗
 */
import Vue from 'vue';
import Dialog from './Dialog.vue';

const DialogConstrutor = Vue.extend(Dialog);

export function showDialog({ content, ...rest }) {
  const instance = new DialogConstrutor();
  instance.$slots.default = [content];
  instance.$mount();
  document.body.appendChild(instance.$el);
  instance.$open({
    ...rest
  });
}
